import { render, staticRenderFns } from "./MenuForm.vue?vue&type=template&id=ec8f0fc2"
import script from "./MenuForm.vue?vue&type=script&lang=js"
export * from "./MenuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec8f0fc2')) {
      api.createRecord('ec8f0fc2', component.options)
    } else {
      api.reload('ec8f0fc2', component.options)
    }
    module.hot.accept("./MenuForm.vue?vue&type=template&id=ec8f0fc2", function () {
      api.rerender('ec8f0fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/menu/MenuForm.vue"
export default component.exports